export default "__VITE_ASSET__sjdMgcCM__"